import * as React from "react";

function SvgCheckmark(props) {
  return <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}><path d="M98.37 15.52a5.559 5.559 0 00-7.86 0L33.33 72.7 9.48 48.85a5.559 5.559 0 00-7.86 7.86L29.4 84.48a5.559 5.559 0 007.86 0l61.11-61.11a5.547 5.547 0 000-7.85z" /></svg>;
}

export default SvgCheckmark;